import mixpanel from 'mixpanel-browser'

const CONSENT_KEY = 'mp:consent'

const readConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY) === 'true' } catch { return false }
}

// Automated browsers (Playwright/Selenium E2E runners) set navigator.webdriver.
// We never opt these into tracking, so test runs don't pollute analytics with
// bot autocapture events or session recordings — even though they grant consent
// to dismiss the cookie banner.
const isAutomated = typeof navigator !== 'undefined' && navigator.webdriver === true

mixpanel.init('e71479be7bf9f6ff1dcd4de18de19e91', {
  opt_out_tracking_by_default: true,
  autocapture: true,
  record_sessions_percent: 100,
  api_host: 'https://api-eu.mixpanel.com',
})

// Restore consent granted in a previous session (never for automated browsers)
if (readConsent() && !isAutomated) {
  mixpanel.opt_in_tracking()
}

export function hasConsent() {
  return readConsent()
}

export function grantConsent() {
  try { localStorage.setItem(CONSENT_KEY, 'true') } catch { /* ignore */ }
  if (!isAutomated) mixpanel.opt_in_tracking()
}

export function revokeConsent() {
  try { localStorage.removeItem(CONSENT_KEY) } catch { /* ignore */ }
  mixpanel.opt_out_tracking()
}

export function identify(userId, profileProps = {}) {
  mixpanel.identify(userId)
  if (Object.keys(profileProps).length > 0) {
    mixpanel.people.set(profileProps)
  }
}

export function reset() {
  mixpanel.reset()
}

export function track(event, props = {}) {
  mixpanel.track(event, props)
}
